export const stringEquals = (value1, value2) => value1 === value2;
